!function(e){"use strict";"function"==typeof define&&define.amd?define("jquery/ui-modules/version",["jquery"],e):e(jQuery)}(function(e){"use strict";return e.ui=e.ui||{},e.ui.version="1.13.2"});
